import { type Context, createContext, useContext } from 'react';

/**
 * @internal
 * DataDtrumContext props
 */
type DataDtrumContextType = {
  dataDtrumMask?: boolean;
  dataDtrumAllow?: boolean;
};

/**
 * @internal
 * Context describing the state of the data-dtrum props
 */
export const DataDtrumContext: Context<DataDtrumContextType> =
  createContext<DataDtrumContextType>({
    dataDtrumMask: undefined,
    dataDtrumAllow: undefined,
  });

/**
 * @internal
 */
export const useDataDtrumContext = () => useContext(DataDtrumContext);
